import { Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router'
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../settings/settings.service';

import { environment } from '../environments/environment';

@Component({
    selector: 'app-home-lemu',
    templateUrl: './home-lemu.component.html',
    styleUrls: ['./home-lemu.component.less'],
    standalone: false
})


export class HomeLemuComponent implements OnInit {

  public systems:any=[];


  constructor(public snackBar: MatSnackBar, public settings: SettingsService, private router: Router) { }


  randomImage: string = '';
  private images: string[] = [
    '../../assets/images/33.jpg',
    '../../assets/images/3.jpg',
    '../../assets/images/4.jpg',
    '../../assets/images/7.jpg',
    '../../assets/images/9.jpg',
    '../../assets/images/12.jpg',
    '../../assets/images/14.jpg',
    '../../assets/images/17.jpg',
    '../../assets/images/23.jpg',
    '../../assets/images/2.jpg',
    '../../assets/images/15.jpg',
    '../../assets/images/26.jpg',
  ];

  //  private images: string[] = [
  //    'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/halloween/Background_4.jpg',
  //    'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/halloween/Background_5.jpg',
  //    'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/halloween/Background_6.jpg',
  //    'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/halloween/Background_7.jpg',
  //  ]

  //navidad
  //  private images: string[] = [
  //    'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/navidad-simpli/Background_1+.jpg',
  //    'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/navidad-simpli/Background_2+.jpg',
  //    'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/navidad-simpli/Background_3+.jpg',
  //  ]

 setRandomBackground(): void {
   const randomIndex = Math.floor(Math.random() * this.images.length);
   this.randomImage = this.images[randomIndex];
 }

  ngOnInit() {
    this.setRandomBackground();
    this.verify();
    this.get_personal_data();

  }

  verify()
  {
    if (localStorage.getItem("token") == null )
    {
     this.router.navigate(['login']);
    }
  }

  logout()
  {
    localStorage.clear()
    this.router.navigate(['login']);
  }


  user:any="";
  avatar:any=null;
  has_avatar:boolean=false;
  loading:boolean=false;
  aux:any[]=[];
public async get_personal_data() {
  this.loading = true;

  try {
    const resultado: any = await this.settings.get_query(1, 'user/');
    const body_data = resultado;

    if (!body_data?.error) {

      const roles = body_data.user.roles;

      this.user = `${body_data.user.first_name} ${body_data.user.last_name}`;
      this.avatar = body_data.user.avatar;

      this.has_avatar = !!body_data.user.avatar;

      this.aux = [];

      for (let i = 0; i < roles.length; i++) {
        for (let j = 0; j < roles[i].systems.length; j++) {
          const s = roles[i].systems[j];
          if (!this.aux.some(e => e.id === s.id)) {
            this.aux.push(s);
          }
        }
      }

    } else {
      throw new Error('error');
    }

  } catch (e) {
    console.error('error', e);
    localStorage.clear();
    this.router.navigate(['login']);
  } finally {
    this.loading = false;
  }
}



  navegar(initials:any, name:any, url:any)
  {
      if (initials == "Ve")
      {
          location.replace(environment.lemu_base+"/login/?email="+localStorage.getItem("email")+"&password="+localStorage.getItem("xrp"));
      }
      else
      {

          
          if(name=="Lemu Inversiones"){

            //  location.replace(url+'prospeccion?token='+localStorage.getItem('token'));
             window.open(url+'?token='+localStorage.getItem('token'), '_blank')
             return;

          }


          if(name=="Ventas" && localStorage.getItem("role")=="admi")
          {
              location.replace(SettingsService.lemu_base + url + "/#/home/admin");
          }
          else
          if (initials == "Tb")
              location.replace(SettingsService.lemu_base + url + "");
          else
              location.replace(SettingsService.lemu_base + url + "/#/home");





          if(name=="Cobranza" && (localStorage.getItem("role")=="ecom" || localStorage.getItem("role")=="eneg" ) )
              location.replace(SettingsService.lemu_base + url + "/#/home/cartera");

      }
  }


}

